import { type Future, future, present } from '@frameio/basics/async/future';
import type { LocaleId } from '../locales';
import { loadLocale, localeFor } from '../locales';
import { createIntl } from './create';
import { type IntlConfig, type IntlShape } from './types';

const INTLS = new Map<LocaleId, Future<IntlShape>>();

export function loadIntl(locale: LocaleId): Future<IntlShape>;
export function loadIntl(spec: string): Future<IntlShape> | null;
export function loadIntl(spec: string): Future<IntlShape> | null {
  const locale = localeFor(spec);
  if (!locale) {
    return null;
  }
  const existing = INTLS.get(locale);
  if (existing) {
    return existing;
  }
  const loading = future(
    loadLocale(locale).then((config) => createIntl(config))
  );
  INTLS.set(locale, loading);
  return loading;
}

export function insertIntl(locale: LocaleId, messages: IntlConfig['messages']) {
  const intl = createIntl({ locale, messages });
  INTLS.set(locale, present(intl));
  return intl;
}
